import React from "react";
import { PUNTOS_EUR, CARNET_EUR } from "@/lib/courses";
import { usePricing } from "@/lib/usePricing";
import "./HorarioCurso.css";

const Bloque = ({ tipo, hora, actividad }) => (
  <div className={`bloque ${tipo}`}>
    <div className="hora">{hora}</div>
    <div className="actividad">{actividad}</div>
  </div>
);

export function HorarioPuntos() {
  const { puntosEur } = usePricing();
  return (
    <div className="faro-horario" data-testid="horario-puntos-html">
      <div className="cabecera">
        <div className="marca">Autoescuelas FARO</div>
        <div className="subtitulo">Recuperación 4 Puntos</div>
        <div className="dia">Viernes</div>
      </div>

      <div className="precio">
        <div className="precio-texto">Precio del curso</div>
        <div className="precio-importe">{puntosEur || PUNTOS_EUR}</div>
      </div>

      <Bloque tipo="profesor" hora="15:00 - 18:00" actividad="Profesor" />
      <Bloque tipo="descanso" hora="18:00 - 18:15" actividad="Descanso" />
      <Bloque tipo="profesor" hora="18:15 - 19:15" actividad="Profesor" />
      <Bloque tipo="psicologo" hora="19:15 - 20:15" actividad="Psicólogo" />
      <Bloque tipo="descanso" hora="20:15 - 20:30" actividad="Descanso" />
      <Bloque tipo="victimas" hora="20:30 - 21:30" actividad="Víctimas" />
      <Bloque tipo="profesor" hora="21:30 - 22:30" actividad="Profesor" />

      <div className="online">
        <div className="online-izquierda">
          <div className="online-titulo">3 horas online</div>
          <div className="online-subtitulo">Contenido a completar de forma autónoma</div>
        </div>
        <div className="online-fecha">
          Hasta el lunes
          <br />
          23:59
        </div>
      </div>
    </div>
  );
}

export function HorarioLeyenda() {
  return (
    <div className="mt-6" data-testid="horario-leyenda">
      <h3 className="font-display font-black text-lg sm:text-xl leading-tight" style={{ color: "#161692" }}>
        Quién imparte cada bloque
      </h3>
      <dl className="mt-3 space-y-3 text-sm sm:text-base text-[var(--faro-text)]">
        <div>
          <dt className="font-black inline" style={{ color: "#161692" }}>Profesor</dt>
          <dd className="inline"> — Formadores viales de nuestro centro, con la formación específica que la DGT exige para los cursos de sensibilización y reeducación vial.</dd>
        </div>
        <div>
          <dt className="font-black inline" style={{ color: "#161692" }}>Psicólogo</dt>
          <dd className="inline"> — Contamos con dos psicólogas para estos cursos, lo que nos permite mantener las convocatorias todos los meses sin depender de una única agenda.</dd>
        </div>
        <div>
          <dt className="font-black inline" style={{ color: "#161692" }}>Víctimas</dt>
          <dd className="inline"> — Testimonio en primera persona de una persona con lesión medular por un accidente de tráfico, a través de una asociación nacional de prevención de accidentes con la que colaboramos. Es la parte del curso que más recuerdan los alumnos.</dd>
        </div>
      </dl>
    </div>
  );
}

export function HorarioCarnet() {
  const { carnetEur } = usePricing();
  return (
    <div className="faro-horario-carnet" data-testid="horario-carnet-html">
      <div className="cabecera">
        <div className="marca">Autoescuelas FARO</div>
        <div className="subtitulo">Recuperación del Carnet</div>
        <div className="titulo">Programación completa</div>
      </div>

      <div className="precio">
        <div className="precio-texto">Precio del curso</div>
        <div className="precio-importe">{carnetEur || CARNET_EUR}</div>
      </div>

      <div className="dia-titulo">1º Viernes</div>
      <Bloque tipo="profesor" hora="15:00 - 18:00" actividad="Profesor" />
      <Bloque tipo="descanso" hora="18:00 - 18:15" actividad="Descanso" />
      <Bloque tipo="profesor" hora="18:15 - 19:15" actividad="Profesor" />
      <Bloque tipo="profesor" hora="19:15 - 20:15" actividad="Profesor" />
      <Bloque tipo="descanso" hora="20:15 - 20:30" actividad="Descanso" />
      <Bloque tipo="profesor" hora="20:30 - 21:30" actividad="Profesor" />
      <Bloque tipo="profesor" hora="21:30 - 22:30" actividad="Profesor" />

      <div className="dia-titulo">Sábado</div>
      <Bloque tipo="profesor" hora="8:00 - 10:00" actividad="Profesor" />
      <Bloque tipo="descanso" hora="10:00 - 10:15" actividad="Descanso" />
      <Bloque tipo="psicologo" hora="10:15 - 12:15" actividad="Psicólogo" />
      <Bloque tipo="descanso" hora="12:15 - 12:30" actividad="Descanso" />
      <Bloque tipo="psicologo" hora="12:30 - 14:30" actividad="Psicólogo" />

      <div className="dia-titulo">2º Viernes</div>
      <Bloque tipo="victimas" hora="17:00 - 18:00" actividad="Víctimas" />
      <Bloque tipo="profesor" hora="18:00 - 20:00" actividad="Profesor" />

      <div className="online">
        <div className="online-izquierda">
          <div className="online-titulo">4 horas online</div>
          <div className="online-subtitulo">Contenido a completar de forma autónoma</div>
        </div>
        <div className="online-fecha">
          Hasta el lunes
          <br />
          23:59
        </div>
      </div>
    </div>
  );
}
